<template>
  <div class="main_container">
    <article class="main_hero">
      <section class="main_card">

        <a-modal class="modal_container modal_large" :width="1000" centered v-if="showModal" :title="`Release Version: ${selectedRelease.version}`"
          :closable="false" centered :visible="true">
          <template slot="footer">
            <a-button key="submit" type="primary" @click="showModal = false">Close</a-button>
          </template>
          <p>Release Date : <span>{{ selectedRelease.release_date }}</span></p>
          <p> Modules:
            <span class="ant-tag ant-tag-blue" v-for="mod in selectedRelease.modules">{{ mod }}</span>
          </p>
          <p>
            Status :
            <span :class="`status-${selectedRelease.status.toLowerCase()}`">
              {{ selectedRelease.status }}
            </span>
          </p>
          <p> Sprint # : <span>{{ selectedRelease.sprint }}</span></p>
          <p>
            Status :
            <span :class="`status-${selectedRelease.status.toLowerCase()}`">
              {{ selectedRelease.status }}
            </span>
          </p>
          <ul class="container_ul">
            <li v-for="item in selectedRelease.description">{{ item }}</li>
          </ul>
        </a-modal>

        <!-- <section class="hero_image">
          <h1>New Release</h1>
          <a-tooltip placement="top">
            <template slot="title">
              <span>Show more details</span>
            </template>

            <div class="new_release_card" v-if="tableData.length !== 0" @click="showDetails(tableDataInstance[0].id)">
              <p><span>Version:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].version : "--/--" }}</p>
              <p><span>Release Date:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].release_date :
                "--/--"
              }}</p>
              <p>
                <span>Modules:
                  <span v-if="tableDataInstance.length !== 0" class="ant-tag ant-tag-blue"
                    v-for="mod in tableDataInstance[0].modules">{{
                      mod }}</span>
                </span>
                {{ tableDataInstance.length === 0 ? "--/--" : '' }}
              </p>
              <p> <span>Status:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].status : "--/--" }}</p>
              <p><span>Sprint #:</span> {{ tableDataInstance.length !== 0 ? tableDataInstance[0].sprint : "--/--" }}</p>
              <p><span>Description:</span></p>
              <p>{{ tableDataInstance.length !== 0 ? tableDataInstance[0].description.slice(0, 1)[0].slice(0, 50) :
                "--/--"
              }}...</p>
            </div>
          </a-tooltip>
        </section> -->

        <section class="release_cards">
          <h2 class="section-title">Latest Releases</h2>
          <div class="card-container">
            <div
              tabindex="0"
              v-for="item in tableDataInstance.slice(0, 3)"
              :key="item.id"
              @click="showDetails(item.id)"
            >
              <a-tooltip placement="top">
                <template slot="title">
                  <span>Show more details</span>
                </template>
                <p><span>Version:</span> {{ item.version }}</p>
                <p><span>Release Date:</span> {{ item.release_date }}</p>
                <p>
                  <span>Modules:
                    <span class="ant-tag ant-tag-blue" v-for="mod in item.modules">{{ mod }}</span>
                  </span>
                </p>
                <p>
                  <span>Status:</span>
                  <span :class="`status-${item.status.toLowerCase()}`">
                    {{ item.status }}
                  </span>
                </p>
                <p><span>Sprint #:</span> {{ item.sprint }}</p>
                <p><span>Description:</span></p>
                <p class="description-preview" v-for="desc in item.description.slice(0, 1)" :key="desc">
                  {{ desc.slice(0, 50) }} <span class="ellipsis">...</span>
                </p>
              </a-tooltip>
            </div>
          </div>
        </section>

        <section
          class="drawer_button"
          :class="{ open: showOlder }"
          @click="showOlder = !showOlder"
        >
          <span>Older Releases</span>
        </section>

        <section
          class="older_releases_drawer"
          :class="{ open: showOlder }"
        >
          <a-table :columns="columns" :data-source="tableData" :pagination="pagination" @change="handleTableChange"
            :loading="loading" :rowKey="(record) => record.id" class="ant-table-striped ant-table" bordered size="small">
            <center slot="action" slot-scope="record">
              <a-button type="primary" @click="showDetails(record)"> View Details </a-button>
            </center>
          </a-table>
      </section>

      </section>
    </article>
  </div>
</template>
<script>
// import secureStorage from '../controllers/secureStorage';
import HTTPRequest from '../controllers/httpRequest'
import { mapState } from 'vuex'
import axios from 'axios';


export default {
  mounted: async function () {
    await this.handleTableChange(this.pagination)
    const { data } = await HTTPRequest.getRequest(`${this.endPoint}releases`)
    this.tableDataInstance = data.map((item) => {
      item.release_date = new Date(item.release_date).toLocaleDateString()
      item.modules = JSON.parse(item.modules)
      item.description = JSON.parse(item.description)
      return item
    })
    // this.tableData = this.tableDataInstance.slice(4)
  },

  methods: {
    async showDetails(id) {
      this.showModal = true
      let data = await HTTPRequest.getRequest(`${this.endPoint}releases/${id}`)
      let release_date = new Date(data.release_date).toLocaleDateString()
      let modules = JSON.parse(data.modules)
      let description = JSON.parse(data.description)
      this.selectedRelease = { ...data, release_date, modules, description }

    },
    async handleTableChange(pagination) {
      this.loading = true
      var pager = { ...this.pagination };
      this.currentPage = pagination.current
      pager.current = pagination.current;
      pager.pageSize = Number(this.default_display);
      this.pagination = pager;
      await HTTPRequest.getRequest(`${this.endPoint}releases?per_page=${this.default_display}&page=${pagination.current}`)
        .then((resp) => {
          var pagination = { ...this.pagination };
          pagination.total = resp.total;
          pagination.pageSize = Number(this.default_display);
          this.pagination = pagination
          let data = resp.data.map((item) => {
            item.release_date = new Date(item.release_date).toLocaleDateString()
            return item
          })
          this.tableData = this.currentPage === 1 ? data.slice(3) : data
        })
      this.loading = false;
    },
  },
  computed: {
    ...mapState(['endPoint', 'profileId', "parameters"]),
  },
  data: function () {
    return {
      showOlder: false,
      tableData: [],
      tableDataInstance: [],
      columns: [
        {
          title: 'Version',
          dataIndex: 'version'
        },
        {
          title: 'Status',
          dataIndex: 'status'
        },
        {
          title: 'Release Date',
          dataIndex: 'release_date'
        },
        {
          title: 'Sprint #',
          dataIndex: 'sprint'
        },
        {
          title: 'Release Notes',
          dataIndex: 'id',
          key: 'x',
          scopedSlots: { customRender: 'action' }
        },
      ],
      spinning: false,
      default_display: 10,
      currentPage: 1,
      pagination: {
        current: 1,
        pageSize: 10,
      },
      loading: false,
      showModal: false,
      selectedRelease: {}
    }
  }
}
</script>
<style scoped>
/* Main classes layout */
* {
  font-size: 12px;
}

.modal_container p,  .modal_container span {
  font-size: 12px;
}
.modal_container p {
  font-weight: bold;
}
.modal_container p span {
  font-weight: normal;
}
.modal_container .container_ul{
  margin-top: 10px;
  border-radius: 5px;
  border: 2px solid rgb(0, 37, 67, 0.5);
  padding: 20px;
  height: 300px;
  overflow: hidden;
  overflow-y: scroll;
}
.modal_container .container_ul li {
  margin-left: 10px;
}

.main_container {
  display: flex;
  flex-direction: column;
}

.main_hero {
  background-color: #ECEEF2;
  padding: 30px;
}

.main_hero p {
  margin: 5px 0;
}

.main_hero span {
  font-weight: bold;
}

.main_card {
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 20px
}

.main_card section {
  margin: 10px 0;
}

/* END*/

/* Hero Image and New Release Layout */
.hero_image {
  background-image: url('../assets/background/RELEASES/releases_background_image.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-areas:
    "col1 col2 col3";
  padding: 120px 0;
}

h2{
  font-size: 1.5rem;
}

.new_release_card {
  grid-area: col3;
  box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -webkit-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
}

/* END */

/* Combined layout for card container and new release card on top */
.card-container {
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;

}

.card-container p {
  margin: 5px 0
}

.card-container div:nth-child(2) {
  margin: 0 20px;
}

.new_release_card,
.card-container div {
  background-color: rgb(255, 255, 255);
  border-radius: 5px;
  border: 2px solid rgb(0, 37, 67, 0.5);
  padding: 10px;
  transition: all .2s;
}

/* END */

/* Drawer Button and Old release drawer layout */
.older_releases_drawer {
  border-radius: 5px;
}

.drawer_button {
  background-color: #C3D5DF;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  transition: all .2s;
}

/* END */

/* Hover Effects */
.drawer_button:hover {
  box-sizing: border-box;
  cursor: pointer;
  color: white;
  background-color: #8EA2B0;
}

.card-container div:hover,
.new_release_card:hover {
  transform: scale(1.01);
  cursor: pointer;
  box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -webkit-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);
  -moz-box-shadow: 9px 10px 13px -5px rgba(0, 0, 0, 0.55);

  /* END */
}

.modal_container .ant-modal-content {
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  padding: 8px;
}

.modal_container .ant-modal-header {
  border-radius: 12px 12px 0 0;
  background: #f5f7fa;
  border-bottom: 1px solid #e8e8e8;
}

.modal_container .ant-modal-title {
  font-weight: 600;
  font-size: 16px;
}

.modal_container p {
  margin-bottom: 10px;
  font-size: 14px;
}

.modal_container span {
  font-weight: 500;
  color: #1890ff;
}

.modal_container p {
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal_container p > span {
  background: #f0f5ff;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 13px;
}

.modal_container .ant-tag {
  margin-right: 6px;
  margin-bottom: 6px;
  border-radius: 6px;
  font-size: 12px;
}

.ant-tag-blue {
  background: #e6f7ff;
  color: #096dd9;
}

.container_ul {
  background: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 12px 18px;
  margin-top: 8px;
}

.container_ul li {
  padding: 6px 0;
  font-size: 13px;
  position: relative;
}

.container_ul li::before {
  content: "•";
  color: #1890ff;
  font-weight: bold;
  margin-right: 8px;
}

.status-active {
  color: #52c41a;
  font-weight: 600;
}

.status-pending {
  color: #faad14;
  font-weight: 600;
}

.status-released {
  color: #1890ff;
  font-weight: 600;
}

.modal_container .ant-modal-footer {
  border-top: none;
}

.modal_container .ant-btn-primary {
  border-radius: 6px;
  padding: 0 20px;
}

.modal_container p,
.modal_container li {
  font-size: 13px;
  line-height: 1.5;
}

.modal_container .ant-modal-body {
  padding: 16px 24px;
}

.modal_container p strong {
  display: block;
  margin-top: 12px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #595959;
}

.release_cards {
  margin-top: 24px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

.card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.card-container > div {
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-container > div:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
  border-color: #1890ff;
}

.card-container p {
  margin-bottom: 6px;
  font-size: 13px;
  line-height: 1.5;
}

.card-container p span {
  font-weight: 600;
  color: #595959;
}

.card-container .ant-tag {
  margin-right: 4px;
  margin-bottom: 4px;
  font-size: 11px;
  border-radius: 6px;
}

.card-container .description-preview {
  color: #8c8c8c;
  font-size: 12px;
}

.card-container .ellipsis {
  color: #1890ff;
  font-weight: 500;
}

.status-released {
  color: #52c41a;
  font-weight: 600;
}

.status-pending {
  color: #faad14;
  font-weight: 600;
}

.ant-tooltip-inner {
  font-size: 12px;
  padding: 6px 10px;
}

.card-container > div:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.4);
}

.modal_large .ant-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.drawer_button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f7fa;
  padding: 12px 16px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  color: #262626;
  margin-top: 24px;
  transition: all 0.25s ease;
}

.drawer_button:hover {
  background: #e6f7ff;
  color: #1890ff;
}

.drawer_button::after {
  content: "›";
  font-size: 20px;
  transition: transform 0.3s ease;
}

.drawer_button.open::after {
  transform: rotate(90deg);
}

.older_releases_drawer {
  max-height: 0;
  overflow: hidden;
  padding: 0;
  margin-top: 0;
  opacity: 0;
  visibility: hidden;
  transition: 
    max-height 0.4s ease,
    opacity 0.3s ease;
}

.older_releases_drawer.open {
  max-height: 1200px; /* enough for table */
  padding: 16px;
  margin-top: 12px;
  opacity: 1;
  visibility: visible;
}

.ant-table-striped .ant-table-tbody > tr:nth-child(odd) {
  background: #fafafa;
}

.ant-table-tbody > tr:hover > td {
  background: #e6f7ff !important;
}

.ant-btn-primary {
  border-radius: 6px;
  font-size: 12px;
}

.ant-btn-primary:hover {
  transform: translateY(-1px);
}

.older_releases_drawer .ant-table {
  font-size: 12px;
}

.older_releases_drawer .ant-table-body {
  max-height: 400px;
  overflow-y: auto;
}


</style>
